(function () {
  const STORAGE_KEY = 'sd-scroll-to';

  document.addEventListener('click', function (event) {
    const link = event.target.closest('[data-sd-scroll-to]');
    if (!link) return;

    const targetId = link.getAttribute('data-sd-scroll-to');
    if (!targetId) return;

    try {
      sessionStorage.setItem(STORAGE_KEY, targetId);
    } catch (error) {
      /* sessionStorage peut être bloqué (mode privé) */
    }
  });
})();
